import React from "react";
import WebcamCapture from "../../../componets/_webCam";
import _params from "../../../componets/_params";

class GetFiles extends React.Component {
  state = {
    files: [],
  };

  uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  }

  uploadFile = async (e) => {
    console.log(this.props);
    await this.props._api({
      ...this.props,
      method: "post",
      endpoint: "/api/service/GetFile/GetFile/" + this.props.params.id,
      data: {
        content: e,
        fileName: "SP_" + this.uuidv4().split("-")[0] + ".jpg",
      },
      param: "",
    });
  };

  componentDidMount() {
    this.props.noui(true);
  }

  render() {
    const { Bs } = this.props;
    return (
      <>
        <Bs row className="gt-4">
          <Bs col xs={12}>
            <WebcamCapture {...this.props} hdr changecam returnImg={this.uploadFile} />
          </Bs>
        </Bs>
      </>
    );
  }
}

export default _params(GetFiles);
